import { render, staticRenderFns } from "./HealthActionCatalogSection.vue?vue&type=template&id=08a29e56"
import script from "./HealthActionCatalogSection.vue?vue&type=script&lang=js"
export * from "./HealthActionCatalogSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports